"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Overlay: true
};
exports.default = exports.Overlay = void 0;
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _react = _interopRequireWildcard(require("react"));
var _nanoid = require("../utils/nanoid");
var _useUpdatesOnlyEffect = require("../utils/useUpdatesOnlyEffect");
var _useOnClickOutside = require("../utils/_useOnClickOutside");
var _Popper = require("../utils/_Popper");
var _useFocusManager = require("../utils/useFocusManager");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Overlay = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Overlay.css") : void 0);
var _Overlay2 = require("./Overlay.types");
Object.keys(_Overlay2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Overlay2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Overlay2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-overlay';
/**
 * Overlay is a generic popover-like component that can be used to render
 * content not typically available in the DOM. The Overlay content can be
 * rendered and shown on either click or hover events and be focus trapped
 * like an HTML dialog.
 */
const Overlay = exports.Overlay = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  var _a, _b, _c, _d;
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(Overlay, _props)) : _props;
  const {
      arrowClassName,
      children,
      className,
      customContainerRef,
      disableEdgeDetection,
      disableFocusManager,
      disableHideWhenTargetIsHidden,
      disablePortal,
      toggleOverlay,
      flipContainer,
      focusManagerProps,
      focusRef,
      hideShadow,
      id,
      innerDialogClassName,
      maxWidth,
      offset = 1,
      popperContentProps = {},
      popperMiddleware,
      popperPlacement = ['bottom-start', 'top-start', 'bottom-end', 'top-end'],
      popperProps = {},
      renderTargetComponent,
      show: showProp = false,
      showArrow,
      skidding,
      skipTargetModifications,
      targetClassName,
      targetComponent,
      targetProps,
      width,
      widthSizingType = 'none',
      widthSizingTargetRef,
      onClickOutside: showOnClickOutside,
      onEscapeKey,
      onHide,
      onKeyDown,
      onShow,
      ignoreStacking
    } = props,
    otherProps = __rest(props, ["arrowClassName", "children", "className", "customContainerRef", "disableEdgeDetection", "disableFocusManager", "disableHideWhenTargetIsHidden", "disablePortal", "toggleOverlay", "flipContainer", "focusManagerProps", "focusRef", "hideShadow", "id", "innerDialogClassName", "maxWidth", "offset", "popperContentProps", "popperMiddleware", "popperPlacement", "popperProps", "renderTargetComponent", "show", "showArrow", "skidding", "skipTargetModifications", "targetClassName", "targetComponent", "targetProps", "width", "widthSizingType", "widthSizingTargetRef", "onClickOutside", "onEscapeKey", "onHide", "onKeyDown", "onShow", "ignoreStacking"]);
  const [show, setShow] = (0, _react.useState)(showProp);
  const popoverRef = (0, _react.useRef)(null);
  const internalTargetRef = (0, _react.useRef)(null);
  const classnames = _bind.default.bind(_Overlay.default);
  let generatedId = (0, _nanoid.generate)();
  if (id) generatedId = id;
  const _id = (0, _react.useRef)(generatedId);
  const handleClickOutside = event => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const {
      target
    } = event;
    // if there are multiple overlays and we are processing the click
    // for the first overlay, let's skip it so the other overlays
    // can handle it.
    const overlays = (_a = document === null || document === void 0 ? void 0 : document.querySelectorAll) === null || _a === void 0 ? void 0 : _a.call(document, 'div[data-overlay]');
    if (!ignoreStacking && overlays.length > 1 && ((_c = (_b = popoverRef.current) === null || _b === void 0 ? void 0 : _b.getAttribute) === null || _c === void 0 ? void 0 : _c.call(_b, 'data-overlay')) === ((_e = (_d = overlays[0]).getAttribute) === null || _e === void 0 ? void 0 : _e.call(_d, 'data-overlay'))) {
      return;
    }
    let targetIsOutside;
    let targetIsTrigger;
    if (typeof target !== 'undefined') {
      targetIsOutside = !((_g = (_f = popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current) === null || _f === void 0 ? void 0 : _f.contains) === null || _g === void 0 ? void 0 : _g.call(_f, target));
      targetIsTrigger = !!(target === (internalTargetRef === null || internalTargetRef === void 0 ? void 0 : internalTargetRef.current) || ((_j = (_h = internalTargetRef === null || internalTargetRef === void 0 ? void 0 : internalTargetRef.current) === null || _h === void 0 ? void 0 : _h.contains) === null || _j === void 0 ? void 0 : _j.call(_h, target)));
    }
    if (!targetIsOutside || targetIsTrigger) {
      // don't close if inside clicked or target clicked
      return;
    }
    // let user decide
    const userShows = !!(showOnClickOutside === null || showOnClickOutside === void 0 ? void 0 : showOnClickOutside(event));
    if (popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current) {
      setShow(userShows);
    }
  };
  (0, _useOnClickOutside.useOnClickOutside)({
    ref: popoverRef,
    handleClickOutside,
    show
  });
  (0, _useFocusManager.useFocusManager)(Object.assign({
    firstFocusIndex: 0
  }, focusManagerProps), !disableFocusManager && show, popoverRef);
  (0, _useUpdatesOnlyEffect.useUpdatesOnlyEffect)(() => {
    if (show) {
      onShow === null || onShow === void 0 ? void 0 : onShow();
    } else {
      onHide === null || onHide === void 0 ? void 0 : onHide();
    }
  }, [show]);
  // map props to state
  (0, _react.useEffect)(() => {
    setShow(showProp);
  }, [showProp]);
  const popperClassName = classnames(CSS_BLOCK, className, {
    [`${CSS_BLOCK}--custom-size`]: !!width,
    [`${CSS_BLOCK}--arrow`]: !hideShadow && showArrow,
    [`${CSS_BLOCK}--no-shadow`]: hideShadow
  });
  let target;
  if (targetComponent && /*#__PURE__*/_react.default.isValidElement(targetComponent)) {
    target = skipTargetModifications ? /*#__PURE__*/_react.default.cloneElement(targetComponent, {
      ref: (0, _reactMergeRefs.default)([(_a = targetComponent.ref) !== null && _a !== void 0 ? _a : null, internalTargetRef])
    }) : /*#__PURE__*/_react.default.cloneElement(targetComponent, {
      'aria-controls': show ? _id.current : null,
      'aria-expanded': show,
      'aria-haspopup': targetComponent.props['aria-haspopup'] || 'dialog',
      onClick: (0, _chainFunction.default)(() => {
        if ((toggleOverlay || !show) && !targetComponent.props.disabled && !targetComponent.props.readOnly) {
          setShow(!show);
        }
      }, targetComponent.props.onClick),
      ref: (0, _reactMergeRefs.default)([(_b = targetComponent.ref) !== null && _b !== void 0 ? _b : null, internalTargetRef])
    });
  }
  // this is a workaround to allow targetComponents wrapped in Tooltips to
  // work. With the above target modifications, the props and ref would be
  // passed to the tooltip's wrapping div, not the actual target component.
  let adjustedRenderTargetComponent = renderTargetComponent;
  if (renderTargetComponent) {
    adjustedRenderTargetComponent = (passedTargetRef, referenceProps, targetClasses, additionalProps) => {
      const mergedRefs = (0, _reactMergeRefs.default)([passedTargetRef, internalTargetRef]);
      const adjustedProps = Object.assign(Object.assign({}, additionalProps), {
        onClick: (0, _chainFunction.default)(() => {
          if ((!show && !toggleOverlay || toggleOverlay) && !(additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.disabled) && !(additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.readOnly)) {
            setShow(!show);
          }
        }, additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.onClick)
      });
      return renderTargetComponent(mergedRefs, referenceProps, targetClasses, adjustedProps);
    };
  }
  const _e = popperContentProps || {},
    {
      className: popperContentClassName
    } = _e,
    otherPopperContentProps = __rest(_e, ["className"]);
  let popperStyleProps = popperProps === null || popperProps === void 0 ? void 0 : popperProps.style;
  if ((_c = width === null || width === void 0 ? void 0 : width.trim) === null || _c === void 0 ? void 0 : _c.call(width)) {
    popperStyleProps = Object.assign(Object.assign({}, popperStyleProps), {
      width
    });
  }
  const extendedPopperProps = Object.assign(Object.assign(Object.assign({
    'data-testid': _id.current,
    id: _id.current,
    role: 'dialog'
  }, otherProps), popperProps), {
    innerRef: (0, _reactMergeRefs.default)([ref, (_d = popperProps.innerRef) !== null && _d !== void 0 ? _d : null]),
    style: popperStyleProps
  });
  return /*#__PURE__*/_react.default.createElement(_Popper.Popper, {
    arrowClassName: classnames(`${CSS_BLOCK}__arrow`, arrowClassName),
    disableHideWhenTargetIsHidden: disableHideWhenTargetIsHidden,
    flipContainer: flipContainer,
    offset: offset,
    onEscapeKey: event => {
      var _a, _b, _c, _d;
      setShow(false);
      (_b = (_a = internalTargetRef === null || internalTargetRef === void 0 ? void 0 : internalTargetRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
      (_d = (_c = focusRef === null || focusRef === void 0 ? void 0 : focusRef.current) === null || _c === void 0 ? void 0 : _c.focus) === null || _d === void 0 ? void 0 : _d.call(_c);
      onEscapeKey === null || onEscapeKey === void 0 ? void 0 : onEscapeKey(event);
    },
    maxWidth: maxWidth,
    popperClassName: popperClassName,
    popperContentProps: Object.assign(Object.assign({}, otherPopperContentProps), {
      className: classnames(`${CSS_BLOCK}__wrapper`, popperContentClassName)
    }),
    popperMiddleware: popperMiddleware,
    popperPlacement: popperPlacement,
    popperProps: extendedPopperProps,
    renderTargetComponent: adjustedRenderTargetComponent,
    show: children && show || undefined,
    showArrow: showArrow,
    targetClassName: targetClassName,
    targetComponent: target,
    targetProps: Object.assign(Object.assign({}, targetProps), {
      'data-overlay-wrapper': true
    }),
    widthSizingType: widthSizingType,
    widthSizingTargetRef: widthSizingTargetRef,
    skidding: skidding,
    onKeyDown: onKeyDown,
    disablePopperContainer: disablePortal,
    disableEdgeDetection: disableEdgeDetection,
    customContainer: customContainerRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-overlay": _id.current,
    ref: popoverRef,
    className: classnames(`${CSS_BLOCK}__dialog`, innerDialogClassName)
  }, children));
});
Overlay.displayName = 'Overlay';
var _default = exports.default = Overlay;